import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import Loader from "../../common/components/Loader";
import ReactPaginate from "react-paginate";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import TableTopIcons from "../../common/components/TableTopIcons";
import { importModalTableData, fileStorageTableData } from "../../../config/tableData";
import Table from "../../reportTemplates/components/TableComponents/Table";
import Portal from "../../common/components/Portal";
import ViewModal from "../../common/components/ViewModal";
import recommendationsActions from "../actions";
import qs from "query-string";
import ViewImportNoteModal from "./ViewImportNoteModal";
import refreshIcon from "../../../assets/img/img-refresh.svg";
import { downloadPresignedUrlFile, downloadBulkPresignedUrlFiles } from "../../common/actions";
import { checkPermission, showAlert as showAlertUtil } from "../../../config/utils";
import { permissions } from "../../../config/permissions";
import ConfirmationModal from "../../common/components/ConfirmationModal";
class ViewImportHistoryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            alertMessage: "",
            paginationParams: {
                totalPages: 0,
                perPage: 100,
                currentPage: 0,
                totalCount: 0
            },
            params: {
                per_page_count: 100,
                page_number: 0,
                search: "",
                order: "",
                filters: null,
                filterKeys: {}
            },
            logs: [],
            tableData: {
                keys: importModalTableData.keys,
                config: _.cloneDeep(importModalTableData.config)
            },
            showWildCardFilter: false,
            showViewModal: false,
            selectedRowId: null,
            showEditExportPage: false,
            basic_details: {
                id: "",
                notes: ""
            },
            exportExcelHistoryLoading: false,
            selectedRecomIds: [],
            showConfirmationModal: false
        };
    }
    componentDidMount = () => {
        this.loadData();
    };
    componentDidUpdate = prevProps => {
        if (prevProps.source !== this.props.source) {
            this.loadData();
        }
    };

    loadData = () => {
        if (this.props.source === "asset_export_history") {
            let tableKeys = [...importModalTableData.keys];
            tableKeys = tableKeys.filter(key => key !== "filter_fields" && key !== "export_notes");
            this.setState(
                {
                    tableData: {
                        keys: tableKeys,
                        config: _.cloneDeep(importModalTableData.config)
                    }
                },
                () => this.refreshImportHistory()
            );
        } else if (this.props.source === "files") {
            this.setState(
                {
                    tableData: {
                        keys: fileStorageTableData.keys,
                        config: _.cloneDeep(fileStorageTableData.config)
                    }
                },
                () => this.refreshImportHistory()
            );
        } else {
            this.setState(
                {
                    tableData: {
                        keys: importModalTableData.keys,
                        config: _.cloneDeep(importModalTableData.config)
                    }
                },
                () => this.refreshImportHistory()
            );
        }
    };
    refreshImportHistory = async () => {
        const { paginationParams, params, tableData } = this.state;
        const { order, per_page_count, page_number, search, filters, filterKeys } = params;
        this.setState({
            isLoading: true
        });
        const { location, source, clientId, regionId, siteId, buildingId, isModal = false } = this.props;
        const query = qs.parse(location.search);
        let ordering = [];
        if (source === "files") {
            ordering = { ...order };
        } else
            ordering = Object.entries(order || [])
                .map(([key, value]) => (value === "asc" ? key : `-${key}`))
                .join(",");
        let param = {
            ...filterKeys,
            per_page_count,
            page_number,
            search,
            filters,
            ...(source === "files" ? { order: ordering } : ordering)
        };
        if (source === "asset_export_history") {
            param.client_id = clientId;
            param.user_id = localStorage.getItem("userId");
            if (regionId) param.region_id = regionId;
            else if (siteId) param.site_id = siteId;
            else if (buildingId) param.building_id = buildingId;
        } else if (source === "files") {
            param.limit = per_page_count;
            param.offset = paginationParams.currentPage + 1;
            param.list = {
                ...(!isModal ? { projects: { id: [query.pid || this.props.match.params.id] } } : {}),
                ...(isModal && (this.props?.projectId || [])?.length ? { projects: { id: this.props?.projectId } } : {}),
                ...(isModal && (this.props?.clientId || [])?.length ? { clients: { id: this.props?.clientId } } : {})
            };
            delete param.page_number;
            delete param.per_page_count;
        } else {
            param.project_id = query.pid || this.props.match.params.id;
        }
        await this.props.getImportViewTableModal(param, source);
        this.setState({
            isLoading: false
        });
        const { exportWordTableResponse } = this.props.recommendationsReducer;
        let totalCount = exportWordTableResponse.count || 0;
        let ResData = exportWordTableResponse?.data;
        // exportWordTableResponse?.message && this.setState({ alertMessage: exportWordTableResponse.message }, () => this.showAlerts());
        ResData &&
            ResData.map(temp => {
                temp.updated_at = moment(temp.updated_at).format("MM-DD-YYYY h:mm A");
                temp.created_at = moment(temp.created_at).format("MM-DD-YYYY h:mm A");
                if (source === "files") {
                    temp.doc_url = temp.s3_url;
                    temp.status = "completed";
                }
            });
        this.setState({
            tableData: {
                ...tableData,
                data: ResData
            },
            showWildCardFilter: this.state.params.filters ? true : false,
            paginationParams: {
                ...paginationParams,
                totalCount: totalCount || "",
                totalPages: Math.ceil(totalCount / paginationParams.perPage)
            }
        });
    };
    updateWildCardFilter = (wildCardFilter, filterKeys) => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    page_number: 0,
                    filters: wildCardFilter,
                    filterKeys
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            },
            () => this.refreshImportHistory()
        );
    };

    resetAllFilters = () => {
        this.setState(
            {
                selectedRegion: null,
                paginationParams: {
                    totalPages: 0,
                    perPage: 100,
                    currentPage: 0,
                    totalCount: 0
                },
                params: {
                    ...this.state.params,
                    per_page_count: 100,
                    page_number: 0,
                    search: "",
                    project_id: null,
                    filters: null,
                    filterKeys: {}
                },
                selectedRowId: null
            },
            () => this.refreshImportHistory()
        );
    };

    resetSort = () => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    order: null
                }
            },
            () => this.refreshImportHistory()
        );
    };

    updateCommonFilter = commonFilters => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    page_number: 0,
                    list: commonFilters
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            },
            () => this.refreshImportHistory()
        );
    };

    updateTableSortFilters = searchKey => {
        if (this.state.params.order) {
            this.setState(
                {
                    params: {
                        ...this.state.params,
                        order: {
                            ...this.state.params.order,
                            [searchKey]: this.state.params.order[searchKey] === "desc" ? "asc" : "desc"
                        }
                    }
                },
                () => this.refreshImportHistory()
            );
        } else {
            this.setState(
                {
                    params: {
                        ...this.state.params,
                        order: { [searchKey]: "asc" }
                    }
                },
                () => this.refreshImportHistory()
            );
        }
    };

    handleHideColumn = async keyItem => {
        let tempTableData = _.cloneDeep(this.state.tableData);
        if (keyItem !== "selectAll" && keyItem !== "deselectAll") {
            if (tempTableData.config[keyItem]) {
                tempTableData.config[keyItem].isVisible = !tempTableData.config[keyItem].isVisible;
            }
        } else {
            tempTableData.keys.forEach(item => {
                if (tempTableData.config[item]) {
                    tempTableData.config[item].isVisible = keyItem === "selectAll";
                }
            });
        }
        await this.setState({
            tableData: tempTableData
        });
        return true;
    };

    updateSelectedRow = async rowId => {
        await this.setState({
            selectedRowId: rowId
        });
    };

    handlePerPageChange = e => {
        const { paginationParams } = this.state;
        this.setState(
            {
                paginationParams: {
                    ...paginationParams,
                    perPage: Number(e.target.value),
                    currentPage: 0
                },
                params: {
                    ...this.state.params,
                    page_number: 0,
                    per_page_count: e.target.value
                }
            },
            () => this.refreshImportHistory()
        );
    };

    handlePageClick = page => {
        const { paginationParams, params } = this.state;
        this.setState(
            {
                paginationParams: {
                    ...paginationParams,
                    currentPage: page.selected
                },
                params: {
                    ...params,
                    page_number: page.selected + 1
                }
            },
            () => this.refreshImportHistory()
        );
    };
    handleGlobalSearch = search => {
        const { params } = this.state;
        this.setState(
            {
                params: {
                    ...params,
                    page_number: 0,
                    search
                },
                paginationParams: {
                    ...this.state.paginationParams,
                    currentPage: 0
                }
            },
            () => this.refreshImportHistory()
        );
    };
    showViewModal = () => {
        this.setState({
            showViewModal: true
        });
    };

    toggleWildCardFilter = () => {
        const { showWildCardFilter } = this.state;
        this.setState({
            showWildCardFilter: !showWildCardFilter
        });
    };

    handleDownloadItemImport = async (url, file) => {
        if (!url) {
            this.setState({ alertMessage: "Oops..! File url not found." }, () => this.showAlerts());
        } else {
            downloadPresignedUrlFile(url);
        }
    };

    showAlerts = () => showAlertUtil(this.state.alertMessage, true);

    showEditExportPage = data => {
        this.setState({
            basic_details: { ...this.state.basic_details, notes: data.export_notes, id: data.id },
            showEditExportPage: true
        });
    };

    handleSelectRecom = (rowData, isChecked) => {
        let { selectedRecomIds } = this.state;
        if (isChecked) {
            this.setState({ selectedRecomIds: [...selectedRecomIds, rowData.id] });
        } else {
            this.setState({ selectedRecomIds: selectedRecomIds.filter(id => id !== rowData.id) });
        }
    };

    handleSelectAllRecom = e => {
        const { tableData, selectedRecomIds } = this.state;
        let tempSelectedRecomIds = [...selectedRecomIds];
        if (e.target.checked) {
            if (tableData && tableData.data) {
                tableData.data.forEach(item => {
                    if (!tempSelectedRecomIds.includes(item.id)) {
                        tempSelectedRecomIds.push(item.id);
                    }
                });
            }
        } else {
            if (tableData && tableData.data) {
                const currentPageIds = tableData.data.map(item => item.id);
                tempSelectedRecomIds = tempSelectedRecomIds.filter(id => !currentPageIds.includes(id));
            }
        }
        this.setState({ selectedRecomIds: tempSelectedRecomIds });
    };

    handleBulkDownload = () => {
        const { selectedRecomIds, tableData } = this.state;
        const selectedFiles = tableData.data
            .filter(item => selectedRecomIds.includes(item.id))
            .map(file => ({
                url: file.doc_url,
                fileName: file.name
            }));
        downloadBulkPresignedUrlFiles(selectedFiles);
    };

    clearSelection = () => {
        this.setState({ selectedRecomIds: [] });
    };

    exportToExcel = async sort_type => {
        this.setState({ exportExcelHistoryLoading: true });
        const { params } = this.state;
        const {
            location: { search },
            source,
            clientId,
            regionId,
            siteId,
            buildingId
        } = this.props;

        const query = qs.parse(search);
        let exportParams = { ...params, sort_type };
        if (source === "asset_export_history") {
            exportParams.client_id = clientId;
            exportParams.user_id = localStorage.getItem("userId");
            if (regionId) exportParams.region_id = regionId;
            else if (siteId) exportParams.site_id = siteId;
            else if (buildingId) exportParams.building_id = buildingId;
        } else {
            exportParams.project_id = query.pid || this.props.match.params.id;
        }
        await this.props.exportToExcel(exportParams, source);
        this.setState({ exportExcelHistoryLoading: false });
        // const res = this.props.recommendationsReducer.exportWordDataResponse;
        // await this.setState({
        //     alertMessage: res?.message_status ? res.message_status : res.message || "Some thing Went Wrong"
        // });
        // this.showAlert();
    };

    handleDelete = async id => {
        this.setState({
            showConfirmationModal: id
        });
    };
    handleDeleteHistory = async () => {
        await this.props?.deleteExportHistory(this.state?.showConfirmationModal, this.props.source);
        const res = this.props.recommendationsReducer.deleteExportHistoryResponse;
        this.setState(
            {
                alertMessage: res?.message || res?.detail || res?.error || "",
                showConfirmationModal: false
            },
            () => {
                this.showAlerts();
                this.refreshImportHistory();
            }
        );
    };

    renderConfirmationModal = () => {
        if (!this.state?.showConfirmationModal) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={`Do you want to delete this ${this.props.source === "files" ? "File" : "Export History"}?`}
                        message={"This action cannot be reverted, are you sure that you need to delete this item?"}
                        onNo={() =>
                            this.setState({
                                showConfirmationModal: false
                            })
                        }
                        onYes={this.handleDeleteHistory}
                    />
                }
                onCancel={() =>
                    this.setState({
                        showConfirmationModal: false
                    })
                }
            />
        );
    };
    render() {
        const {
            paginationParams,
            exportExcelHistoryLoading,
            showEditExportPage,
            isLoading,
            showViewModal,
            showWildCardFilter,
            tableData,
            params,
            selectedRowId,
            selectedRecomIds
        } = this.state;
        const { source } = this.props;
        const everyItemCheckedPerPage = tableData.data && tableData.data.length && tableData.data.every(item => selectedRecomIds.includes(item.id));
        return (
            <LoadingOverlay active={isLoading} spinner={<Loader />} fadeSpeed={10}>
                <div className="dtl-sec col-md-12 view-import-histort-main">
                    <div className="table-top-menu allign-right">
                        <button
                            className="btn btn-edit refresh-btn mt-2"
                            onClick={e => {
                                e.preventDefault();
                                this.refreshImportHistory();
                            }}
                        >
                            <span className="icon mr-1">
                                <img src={refreshIcon} alt="" />
                            </span>
                            <span className="text">Refresh</span>
                        </button>
                        <div className="rgt">
                            <TableTopIcons
                                globalSearchKey={params.search}
                                handleGlobalSearch={this.handleGlobalSearch}
                                resetAllFilters={this.resetAllFilters}
                                toggleWildCardFilter={this.toggleWildCardFilter}
                                showViewModal={this.showViewModal}
                                resetSort={this.resetSort}
                                tableParams={params}
                                showWildCardFilter={showWildCardFilter}
                                exportToExcelFromExportHistory={this.exportToExcel}
                                exportExcelHistoryLoading={exportExcelHistoryLoading}
                                isExport={
                                    source !== "files" &&
                                    source !== "asset_export_history" &&
                                    checkPermission("forms", permissions.PROJECT_EXPORT_HISTORY, "export")
                                }
                            />
                        </div>
                    </div>
                    {source === "files" && selectedRecomIds.length > 0 ? (
                        <div className="d-flex wrapper-icon-full mb-2">
                            <button className={`add-btn ml-2 btn-new-noti`} onClick={e => e.preventDefault()}>
                                <i className="fas fa-check" />
                                <span>{selectedRecomIds?.length}</span>
                            </button>
                            <button className={"add-btn ml-2 btn-new-noti"} onClick={() => this.handleBulkDownload()}>
                                <i className="fas fa-download mr-1" /> {`Export Selected`}
                            </button>
                            <button
                                className={"add-btn ml-2 btn-new-noti"}
                                onClick={e => {
                                    e.preventDefault();
                                    this.clearSelection();
                                }}
                            >
                                <i className="fas fa-times-circle mr-1" /> {`Clear`}
                            </button>
                        </div>
                    ) : null}
                    <div className="table-section build-table">
                        <Table
                            tableData={tableData}
                            showWildCardFilter={showWildCardFilter}
                            updateSelectedRow={this.updateSelectedRow}
                            selectedRowId={selectedRowId}
                            updateWildCardFilter={this.updateWildCardFilter}
                            wildCardFilter={params}
                            handleHideColumn={this.handleHideColumn}
                            updateTableSortFilters={this.updateTableSortFilters}
                            tableParams={params}
                            hasTableImport={true}
                            hasDelete={true}
                            hasInfoPage={false}
                            hasEdit={this.props.source !== "files"}
                            handleDownloadItemImport={this.handleDownloadItemImport}
                            showEditExportPage={this.showEditExportPage}
                            isImportHistoryTable={true}
                            hasMultiAction={false}
                            selectedRecomIds={selectedRecomIds}
                            handleSelectRecom={this.handleSelectRecom}
                            handleSelectAllRecom={this.handleSelectAllRecom}
                            everyItemCheckedPerPage={everyItemCheckedPerPage}
                            hasExport={source === "files" ? checkPermission("forms", permissions.FILE_STORAGE, "export") : true}
                            handleDeleteItem={this.handleDelete}
                        />
                        {tableData.data && tableData.data.length ? (
                            <div className="table-bottom d-flex">
                                <div className="count d-flex col-md-6">
                                    <div className="count-dtl">
                                        Total Count: <span>{paginationParams.totalCount}</span>
                                    </div>
                                    <div className="col-md-2 pr-2 selbx">
                                        <select className="form-control" value={paginationParams.perPage} onChange={e => this.handlePerPageChange(e)}>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                            <option value="40">40</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="150">150</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="pagination-sec col-md-6">
                                    <ReactPaginate
                                        previousLabel={
                                            <span data-place="top" data-effect="solid" data-tip={`Previous`} data-background-color="#007bff">
                                                &lt;
                                            </span>
                                        }
                                        nextLabel={
                                            <span data-place="top" data-effect="solid" data-tip={`Next`} data-background-color="#007bff">
                                                &gt;
                                            </span>
                                        }
                                        breakLabel={"..."}
                                        breakClassName={"break-me"}
                                        pageCount={paginationParams.totalPages}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        activeLinkClassName={"active"}
                                        forcePage={paginationParams.currentPage}
                                    />
                                    <ReactTooltip />
                                </div>
                            </div>
                        ) : null}
                        {showEditExportPage ? (
                            <Portal
                                body={
                                    <ViewImportNoteModal
                                        refreshImportHistory={this.refreshImportHistory}
                                        basic_details={this.state.basic_details}
                                        onCancel={() => this.setState({ showEditExportPage: false })}
                                    />
                                }
                                onCancel={() => this.setState({ showEditExportPage: false })}
                            />
                        ) : null}

                        {showViewModal ? (
                            <Portal
                                body={
                                    <ViewModal
                                        keys={tableData.keys}
                                        config={tableData.config}
                                        handleHideColumn={this.handleHideColumn}
                                        onCancel={() => this.setState({ showViewModal: false })}
                                    />
                                }
                                onCancel={() => this.setState({ showViewModal: false })}
                            />
                        ) : null}
                    </div>
                </div>
                {this.renderConfirmationModal()}
            </LoadingOverlay>
        );
    }
}
const mapStateToProps = state => {
    const { recommendationsReducer } = state;
    return { recommendationsReducer };
};

export default withRouter(connect(mapStateToProps, { ...recommendationsActions })(ViewImportHistoryTable));
